import { createSlice } from '@reduxjs/toolkit';

export interface DataUploadState {
  uploaded: boolean;
  inProgress: boolean;
}

const initialState: DataUploadState = {
  uploaded: false,
  inProgress: false,
};

const dataUploadSlice = createSlice({
  name: 'dataUpload',
  initialState,
  reducers: {
    setProgress: (state, action) => {
      state.uploaded = action.payload.uploaded || false;
      state.inProgress = action.payload.inProgress || false;
    },
  },
});

const { actions, reducer } = dataUploadSlice;
export const { setProgress } = actions;
export default reducer;
